(function () {
  var overlayLayer = document.getElementById("overlay-demo-layer");
  var overlayStatus = document.getElementById("overlay-demo-status");
  var controlStatus = document.getElementById("overlay-demo-control-status");
  var toggleButton = document.getElementById("overlay-demo-toggle");
  var simulateButton = document.getElementById("overlay-demo-simulate");
  var isVisible = false;
  var simulationToken = 0;
  var simulationTimers = [];

  if (!overlayLayer || !overlayStatus || !toggleButton || !simulateButton) {
    return;
  }

  function setControlStatus(text) {
    if (controlStatus) {
      controlStatus.textContent = text;
    }
  }

  function clearSimulationTimers() {
    for (var i = 0; i < simulationTimers.length; i++) {
      window.clearTimeout(simulationTimers[i]);
    }
    simulationTimers = [];
  }

  function setOverlayVisible(visible) {
    isVisible = visible;
    overlayLayer.classList.toggle("is-hidden", !visible);
    toggleButton.textContent = visible ? "Hide Overlay" : "Show Overlay";
    if (visible) {
      overlayStatus.textContent = "Loading...";
    }
    setControlStatus(visible ? "Status: Overlay visible." : "Status: Overlay hidden.");
  }

  toggleButton.addEventListener("click", function () {
    simulationToken += 1;
    clearSimulationTimers();
    setOverlayVisible(!isVisible);
  });

  simulateButton.addEventListener("click", function () {
    simulationToken += 1;
    clearSimulationTimers();
    var token = simulationToken;

    setOverlayVisible(true);
    overlayStatus.textContent = "Loading...";
    setControlStatus("Status: Simulating loading.");

    simulationTimers.push(window.setTimeout(function () {
      if (token !== simulationToken) {
        return;
      }
      overlayStatus.textContent = "Loading complete";
    }, 900));

    simulationTimers.push(window.setTimeout(function () {
      if (token !== simulationToken) {
        return;
      }
      setOverlayVisible(false);
      setControlStatus("Status: Loading simulation complete.");
    }, 1500));
  });

  setOverlayVisible(false);
})();
